import {AfterViewInit, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {CommonModule} from '@angular/common';
import {Helpers} from "../helpers";

@Component({
  selector: 'tag-dropdown',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './tag-dropdown.component.html',
  styleUrls: ['./tag-dropdown.component.scss']
})
export class TagDropdownComponent implements AfterViewInit, OnChanges {
  debounced_search: Function;

  constructor() {
    this.debounced_search = Helpers.debounce((val: string) => this.search(val));
  }

  @Output() change: EventEmitter<any> = new EventEmitter<any>();

  @Input() placeholder: string = "Select a value"

  @Input() selected: any[] = [];

  @Input() values: any[] = []

  @Input() identifier: string = "value";

  @Input() label: string = "label";

  _values: any[] = [];

  toggle: boolean = false;

  ngAfterViewInit() {
    this._values = structuredClone(this.values);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes['values']){
      this.values = changes['values']?.currentValue ?? [];
      this._values = structuredClone(this.values);
    }
  }

  search(value: string) {
    this._values = structuredClone(this.values)
      .filter((v: any) => this.selected.map(s => s[this.identifier]).indexOf(v[this.identifier]) == -1);

    if (value.length > 0) {
      this._values = this._values
        .filter((v: any) => v[this.label].toLowerCase().indexOf(value.toLowerCase()) != -1);
    }
  }

  remove(value: any) {
    this.selected = this.selected.filter(s => s[this.identifier] != value[this.identifier]);
    this._values = structuredClone(this.values)
      .filter((v: any) => this.selected.map(s => s[this.identifier]).indexOf(v[this.identifier]) == -1);

    this.change.emit(this.selected);
  }

  select(value: any | undefined) {
    this._values = this._values.filter(v => v[this.identifier] != value[this.identifier])
    this.selected?.push(value);

    this.change.emit(this.selected);
    this.trigger();
  }

  clear(){
    this._values = structuredClone(this.values);
    this.selected = [];
  }

  trigger() {
    this.toggle = !this.toggle;
  }
}
